import { render, staticRenderFns } from "./merge-organizations.vue?vue&type=template&id=13a6734e"
import script from "./merge-organizations.ts?vue&type=script&lang=js&external"
export * from "./merge-organizations.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports